import { render, staticRenderFns } from "./vcard.vue?vue&type=template&id=2d5a0a32&"
import script from "./vcard.vue?vue&type=script&lang=ts&"
export * from "./vcard.vue?vue&type=script&lang=ts&"
import style0 from "./vcard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports